import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, GiftIcon, CreditCardIcon, CoinsIcon, ArrowLeftRightIcon, PiggyBankIcon, ReceiptIcon, IdCardIcon, LifeBuoyIcon } from 'lucide-react';
interface SidebarProps {
  mobile?: boolean;
}
export function Sidebar({
  mobile = false
}: SidebarProps) {
  return <div className="flex flex-col flex-grow pt-5 pb-4 overflow-y-auto" data-id="element-58">
      <div className="flex items-center flex-shrink-0 px-4" data-id="element-59">
        <h1 className="text-2xl font-bold text-blue-600" data-id="element-60">Oxy Pay</h1>
      </div>
      <nav className="mt-5 flex-1 px-2 bg-white space-y-1" data-id="element-61">
        <NavItem to="/" icon={<HomeIcon className="mr-3 h-6 w-6" data-id="element-63" />} label="Dashboard" data-id="element-62" />
        <NavItem to="/gift-cards" icon={<GiftIcon className="mr-3 h-6 w-6" data-id="element-65" />} label="Gift Cards" data-id="element-64" />
        <NavItem to="/virtual-cards" icon={<CreditCardIcon className="mr-3 h-6 w-6" data-id="element-67" />} label="Virtual Cards" data-id="element-66" />
        <NavItem to="/crypto" icon={<CoinsIcon className="mr-3 h-6 w-6" data-id="element-69" />} label="Crypto" data-id="element-68" />
        <NavItem to="/crypto-swap" icon={<ArrowLeftRightIcon className="mr-3 h-6 w-6" data-id="element-71" />} label="Crypto Swap" data-id="element-70" />
        <NavItem to="/savings" icon={<PiggyBankIcon className="mr-3 h-6 w-6" data-id="element-73" />} label="Savings" data-id="element-72" />
        <NavItem to="/bill-payment" icon={<ReceiptIcon className="mr-3 h-6 w-6" data-id="element-75" />} label="Bill Payment" data-id="element-74" />
        <NavItem to="/nin-printing" icon={<IdCardIcon className="mr-3 h-6 w-6" data-id="element-77" />} label="NIN Virtual" data-id="element-76" />
        <NavItem to="/support" icon={<LifeBuoyIcon className="mr-3 h-6 w-6" data-id="element-79" />} label="Support" data-id="element-78" />
      </nav>
    </div>;
}
interface NavItemProps {
  to: string;
  icon: React.ReactNode;
  label: string;
}
function NavItem({
  to,
  icon,
  label
}: NavItemProps) {
  return <NavLink to={to} className={({
    isActive
  }) => `group flex items-center px-2 py-2 text-base font-medium rounded-md ${isActive ? 'bg-blue-100 text-blue-600' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-80">
      {icon}
      {label}
    </NavLink>;
}